/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import Map from 'scripts/models/base/map';
import can from 'can';
import template from './type.stache';
import dtm from 'scripts/services/dtm';

Component.extend({
    tag: 'timeline-type-filter',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            activeCategories: {
                Type: can.List,
                Value: can.List,
            },
            types: {
                Type: Map,
                get() {
                    const types = {
                        all: 'All',
                        videos: 'Videos',
                        articles: 'Articles',
                        photos: 'Photos',
                        social: 'Social',
                    };
                    const activeCategories = this.attr('activeCategories');
                    const isVictoryClubPage = this.attr('isVictoryClubPage');
                    if (isVictoryClubPage) {
                        delete types.social;
                    }
                    if (!activeCategories || !activeCategories.length) {
                        return new Map(types);
                    } else {
                        const filteredTypes = {};
                        activeCategories.forEach((categoryKey) => {
                            if (types[categoryKey]) {
                                filteredTypes[categoryKey] = types[categoryKey];
                            }
                        });
                        return new Map(filteredTypes);
                    }
                },
            },
        },
        onChange: function(event) {
            if (event && event.payload) {
                this.selectType(event.payload.value);
                if (this.attr('isVictoryClubPage')) {
                    dtm.trackLatestContentFilterChange(event.payload.value);
                }
            }
        },
        selectType: function(value) {
            this.dispatch({ type: 'filter', payload: { type: value } });
        },
    },
    events: {
        inserted() {
            this.viewModel.selectType('all');
        },
    },
});
